import { render } from "./EditProfilePage.vue?vue&type=template&id=63587602&ts=true"
import script from "./EditProfilePage.vue?vue&type=script&lang=ts"
export * from "./EditProfilePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__